import React from 'react';
import { useParams, useNavigate, Navigate } from 'react-router-dom';
import MapDisplay from '../components/MapDisplay';
import { FaChevronLeft, FaChevronRight, FaMapMarkerAlt } from 'react-icons/fa';
import markersData from '../data/markers.json';

const ADVENTURES = [
  {
    id: 'mt-hood',
    title: 'Mt. Hood Summit',
    url: '/tracks/mt-hood.gpx',
    stats: 'Climb • Volcano'
  },
  {
    id: 'eldorado-peak',
    title: 'Eldorado Peak',
    url: '/tracks/eldorado-peak.gpx',
    stats: 'Mountaineering'
  },
  {
    id: 'cask-lake',
    title: 'Saturday Hike to Cask Lake',
    url: '/tracks/cask-lake.gpx',
    stats: 'Alpine Lake Hike'
  },
  {
    id: 'glacier-peak',
    title: 'Glacier Peak',
    url: '/tracks/glacier-peak.gpx',
    stats: 'Mountaineering'
  }
];

function Adventures() {
  const { id } = useParams();
  const navigate = useNavigate();

  if (!id && ADVENTURES.length > 0) {
    return <Navigate to={`/adventures/${ADVENTURES[0].id}`} replace />;
  }

  const foundIndex = ADVENTURES.findIndex(a => a.id === id);
  const currentIndex = foundIndex !== -1 ? foundIndex : 0;

  const nextAdventure = () => {
    const nextIdx = (currentIndex + 1) % ADVENTURES.length;
    navigate(`/adventures/${ADVENTURES[nextIdx].id}`);
  };
  const prevAdventure = () => {
    const prevIdx = (currentIndex - 1 + ADVENTURES.length) % ADVENTURES.length;
    navigate(`/adventures/${ADVENTURES[prevIdx].id}`);
  };

  const current = ADVENTURES[currentIndex];

  return (
    <div className="adventures-container">
      
      {/* Full Screen 3D Map */}
      <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0 }}>
        <MapDisplay trackUrl={current.url} markers={markersData[current.id] || []} />
      </div>

      {/* Floating Glass HUD */}
      <div style={{
        position: 'absolute',
        bottom: '30px',
        left: '50%',
        transform: 'translateX(-50%)',
        background: 'rgba(10, 10, 10, 0.7)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '100px',
        padding: '12px 24px',
        display: 'flex',
        alignItems: 'center',
        gap: '20px',
        boxShadow: '0 10px 30px rgba(0,0,0,0.5)',
        zIndex: 10,
        width: '90%',
        maxWidth: '500px'
      }}>
        
        {/* Previous Button */}
        <button onClick={prevAdventure} className="adv-nav-btn">
          <FaChevronLeft />
        </button>

        {/* Info */}
        <div style={{ flex: 1, textAlign: 'center' }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', color: '#ff4d4d', marginBottom: '2px', fontSize: '0.75rem', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '1px' }}>
            <FaMapMarkerAlt /> {current.stats}
          </div>
          <h2 style={{ fontSize: '1.2rem', margin: 0, color: '#fff', letterSpacing: '-0.2px' }}>{current.title}</h2>
          
          {/* Pagination Dots */}
          <div style={{ marginTop: '8px', display: 'flex', justifyContent: 'center', gap: '6px' }}>
            {ADVENTURES.map((_, idx) => (
              <div key={idx} style={{
                width: '6px', height: '6px', borderRadius: '50%',
                background: idx === currentIndex ? '#ff4d4d' : 'rgba(255,255,255,0.2)',
                transition: 'background 0.3s'
              }} />
            ))}
          </div>
        </div>

        {/* Next Button */}
        <button onClick={nextAdventure} className="adv-nav-btn">
          <FaChevronRight />
        </button>
      </div>
    </div>
  );
}

export default Adventures;
